/**
 * Agency branding helpers for tenant-branded surfaces.
 *
 * Brand values are per-tenant runtime data, so they cannot be design tokens. The
 * rule the design system does impose still holds: a brand colour is applied as an
 * accent — a logo, a rule, a chip — never as the background behind token-coloured
 * text. An agency can set any colour, including a near-white one, and
 * `--lc-text-on-inverse` on top of it would fail contrast. Where a brand colour is
 * absent these helpers fall back to the semantic tokens.
 */
import type { AgencyBrandFont } from '@/types/agencyBranding'

/** Maps the four allowed brand fonts onto the font stacks the app ships. */
export function brandFontFamily(font?: AgencyBrandFont | string | null): string {
  if (font === 'archivo') return 'var(--lc-font-display)'
  if (font === 'playfair-display') return 'Playfair Display, serif'
  return 'var(--lc-font-ui)'
}

/** A brand colour, or the semantic action colour when the agency has not set one. */
export function brandPrimary(color?: string | null): string {
  return color || 'var(--lc-action-primary)'
}
